/*[2/24/22, PC_DP_06, Priyanka D]*/
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';

const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
/*[2/24/22, PC_DP_12, Priyanka D]*/
const Pageload = (PageLoadBO) => {
    try {
        ////debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.DefaultPutAwayLocations,
            SDIConstants.methodNames.DefaultPutAway_Pageload,
            JSON.stringify(PageLoadBO),
            (data) => {
                if (data.success) {
                    ////debugger
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PageLoadResponse", response: data.response, isException: true };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/*[2/24/22, PC_DP_22, Priyanka D]*/
const Search = (SearchBO) => {
    try {
        ////debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.DefaultPutAwayLocations,
            SDIConstants.methodNames.DefaultPutAway_Search,
            JSON.stringify(SearchBO),
            (data) => {
                if (data.success) {
                    ////debugger
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SearchResponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/*[2/25/22, PC_DP_30, Priyanka D]*/
const AddNewLoc = (AddNewBO) => {
    try {
        ////debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.DefaultPutAwayLocations,
            SDIConstants.methodNames.DefaultPutAway_AddNew,
            JSON.stringify(AddNewBO),
            (data) => {
                if (data.success) {
                    ////debugger
                    if (data.response != "" && data.response) {
                        let contentData = { type: "AddNewResponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/*[2/25/22, PC_DP_44, Priyanka D]*/
const Save = (SaveBO) => {
    try {
        ////debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.DefaultPutAwayLocations,
            SDIConstants.methodNames.DefaultPutAway_Save,
            JSON.stringify(SaveBO),
            (data) => {
                if (data.success) {
                    ////debugger
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SaveResponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
export { Pageload, Search, AddNewLoc, Save, insertFavPage, deleteFavPage, getCurrentFavPage }
